
import type { PropType } from 'vue'
import type { Placement } from '@floating-ui/vue'

import { defineComponent } from 'vue'

// Components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// Composable
import useTooltip from '@/common/composable/useTooltip'
import useClickOutside from '@/common/composable/useClickOutside'

export default defineComponent({
    name: 'button-dropdown',
    components: { TheButton },
    props: {
        title: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isTable: {
            type: Boolean,
            default: false,
        },
        strategy: {
            type: String as PropType<'absolute' | 'fixed'>,
            default: 'absolute'
        },
        placement: {
            type: String as PropType<Placement>,
            default: 'left-start'
        },
        allowedPlacements: {
            type: Array as PropType<Placement[]>,
            default: () => ['left-start', 'top', 'top-start', 'top-end'],
        }
    },
    setup(props) {
        const openDropdown = () => {
            if (props.disabled) return
            open()
        }

        const closeDropdown = () => {
            close()
        }

        const { reference, tooltip, isVisible, x, y, strategy, open, close } = useTooltip({
            placement: props.placement,
            strategy: props.strategy,
            offset: 16,
            autoPlacement: {
                allowedPlacements: props.allowedPlacements,
            },
        })

        useClickOutside(reference, closeDropdown)

        return {
            openDropdown,
            reference,
            tooltip,
            isVisible,
            x,
            y,
            strategy
        }
    },
})
